import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, useGrid, useStore, useToast, usePage } from "@/comn/hooks";
import {
    APIS,
    SF_BLTBRD_MGMT_SRCH,
    SG_BLTBRD_MGMT_LIST,
    URLS,
} from "@/tz/go/egaz/osci/ptl/sysm/bltbrd/services/OscibltbrdService";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*
 * Bulletin board Management List
 * !== 게시판 관리 목록 ==!
 */
export const OSCI0111013Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    // {pgeUid: "osci0111013q"}
    const modal = useModal();
    const navigate = useNavigate();
    const toast = useToast();
    const { pgeStore, getStore, setStore } = useStore({ pgeUid: pgeUid });

    const form = {
        bltbrdSrch: useForm({
            defaultSchema: SF_BLTBRD_MGMT_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };
    const grid = {
        bltbrdList: useGrid({
            defaultSchema: SG_BLTBRD_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getbltbrdList: useFetch({
            api: (page = grid.bltbrdList.page) =>
                APIS.getbltbrdList(form.bltbrdSrch.getValues(), page, grid.bltbrdList.size),
            enabled: comnUtils.isEmpty(form.bltbrdSrch.errors),
            key: [grid.bltbrdList.page, grid.bltbrdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.bltbrdSrch.getValues(),
                    page: grid.bltbrdList.page,
                    size: grid.bltbrdList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onSrchBtnClick: () => {
            fetch.getbltbrdList.fetch(0);
        },
        onMenuNewBtnClick: () => {
            navigate(`${URLS.osci0111014s}?menuId=${menuId}`);
        },
        grid_bltbrdDtl: (data: any) => {
            setStore(pgeUid, {
                form: form.bltbrdSrch.getValues(),
                page: grid.bltbrdList.page,
                size: grid.bltbrdList.size,
            });
            navigate(`${URLS.osci0111015s}/${data.rowValues.bltbrdId}?menuId=${menuId}`);
        },
        IQSTest: () => {
            const modalCallback = (data: any) => {
                if (data) {
                    modal.closeModal();
                    toast.showToast({ content: "msg.osc.00006" }); // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                }
            };
            const TestParam = {
                comnCd: "OSC0039",
                bsopId: "testBSOP",
                trgtDispYn: "Y",
                docCdVal: "edoc_ptl0003",
                iqsSbjctlList: [
                    {
                        iqsSbjctlLblNm: "Reference No.",
                        iqsSbjctlTpCd: "T",
                        defaultValue: "135061158-22-9700245",
                        editable: false,
                        required: false,
                    },
                    {
                        iqsSbjctlLblNm: "Date of Registration",
                        iqsSbjctlTpCd: "T",
                        defaultValue: "01/09/2023",
                        editable: "false",
                        required: false,
                    },
                    {
                        iqsSbjctlLblNm: "Mode of Declaration",
                        iqsSbjctlTpCd: "C",
                        comnCd: "OSC0042",
                        defaultValue: "EX1",
                        editable: "false",
                        required: true,
                    },
                    {
                        iqsSbjctlLblNm: " CL. Plan",
                        iqsSbjctlTpCd: "C",
                        comnCd: "OSC0023",
                        defaultValue: "PAD",
                        required: "true",
                    },
                    { iqsSbjctlLblNm: "Invoice No.", iqsSbjctlTpCd: "T", defaultValue: "25A2324", required: "true" },
                    {
                        iqsSbjctlLblNm: "Total Invoice Value",
                        iqsSbjctlTpCd: "T",
                        defaultValue: "2,623,78(USD)",
                        required: "true",
                    },
                    {
                        iqsSbjctlLblNm: "Status",
                        iqsSbjctlTpCd: "C",
                        comnCd: "OSC0045",
                        defaultValue: "C",
                        required: "false",
                    },
                    {
                        iqsSbjctlLblNm: "Total Custims Value",
                        iqsSbjctlTpCd: "T",
                        defaultValue: "6,752,949.2",
                        required: "false",
                    },
                ],
                iqsTrgtList: ["CUO", "MELLA", "MOFEDG3"],
            };
            modal.openModal({
                url: `http://tancis.singlewindow.info:30090/ptli/mypage/myiqs/ptli0304003s`,
                params: TestParam,
                size: "md",
                callback: modalCallback,
            });
        },
        onClear: () => {
            form.bltbrdSrch.clearValues();
            form.bltbrdSrch.setValues({ bltbrdEngNm: "", bltbrdTzNm: "", bltbrdKorNm: "" });
        },
    };

    const render = {
        grid_BtbdmsList: {
            cell: {
                bltbrdEngNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    setStore(pgeUid, {
                        form: form.bltbrdSrch.getValues(),
                        page: grid.bltbrdList.page,
                        size: grid.bltbrdList.size,
                    });
                    return <Link to={`${URLS.osci0111015s}/${rowValues.bltbrdId}?menuId=${menuId}`}>{value}</Link>;
                },
            },
        },
    };

    useEffect(() => {
        handler.onSrchBtnClick();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    {/* <Group.Section>
                        <Button onClick={handler.IQSTest}>IQS 팝업 Test</Button>
                    </Group.Section> */}
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bltbrdSrch.schema.bltbrdEngNm} controlSize={2} />
                            <Group.Control {...form.bltbrdSrch.schema.bltbrdTzNm} controlSize={2} />
                            <Group.Control {...form.bltbrdSrch.schema.bltbrdKorNm} controlSize={2} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => handler.onClear()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.bltbrdList.grid}
                            data={fetch.getbltbrdList.data?.bltbrdList}
                            render={render.grid_BtbdmsList}
                            // onCellClick={handler.grid_bltbrdDtl}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"new"} onClick={handler.onMenuNewBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
